<template>
  <div class="content-container">
    <search-comp
      :search-show="true"
      @onSearch="attachData"
      @onReset="onResetSearchParams"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <!-- <CalendarSelect
                  v-model="dateSearch"
                  style="display: block; width: 200px"
                  mode="date"
                /> -->
                <CalendarSelect
                  v-model="searchParams.date"
                  style="display: block"
                  mode="date"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :context="context"
      />
    </div>

    <div class="button-containers">
      <button class="btn primary small" @click="updateBreakfast">
        {{ $t('button.save') }}
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { component as VueNumber } from '@coders-tm/vue-number-format'
import {
  CellRenderNumberInputBySum,
  CellRenderTextInput
} from '@/utils/cellRenders'
import { getAllHotel } from '@/api/hotel'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import {
  getHistoryBreakfast,
  setHistoryBreakfast
} from '@/api/business_area_service/breakfastReal'
import Vue from 'vue'

const CellRenderNoteInput = Vue.extend({
  data() {
    return {
      value: '',
      colName: null
    }
  },
  watch: {
    value() {
      this.params.context.componentParent.textInputChange(
        this.params,
        this.value,
        this.colName
      )
    }
  },
  beforeMount() {
    if (this.params?.value !== null && this.params?.value !== undefined) {
      this.value = this.params.value
    }
    this.params.colName
      ? (this.colName = this.params.colName)
      : (this.colName = this.params.column.colId)
  },
  methods: {
    // changeInput(e) {
    //   const value = e.target.value
    //   this.params.context.componentParent.textInputChange(
    //     this.params,
    //     value,
    //     this.colName
    //   )
    // }
  },
  template: `<input class="input-text-border-none" :maxlength='50' min='0' type="text" v-model="value" />`
})

export default {
  components: {
    Breadcrumb,
    RightPanel,
    SelectWithSearchTable,
    VueNumber,
    CellRenderNumberInputBySum,
    CalendarSelect,
    CellRenderTextInput,
    CellRenderNoteInput
  },
  data() {
    return {
      flagCanSave: true,
      dateSearch: this.$moment().format('YYYY-MM-DD'),
      loading: false,
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      listAssign: [],
      searchParams: {
        // pageSize: 10,
        // pageNum: 1,
        // orderTp: 'ASC',
        // roomLevelId: '',
        // roomNumber: '',
        // hotelId: '',
        date: this.$moment(new Date()).format('YYYY-MM-DD')
      },

      context: null,
      columns: [
        {
          headerName: this.$t('grid.column.order1'),
          field: 'row_num',
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'room_num',
          sortable: false,
          width: 100,
          minWidth: 140,
          maxWidth: 200,
          wrapText: true,
          autoHeight: true
        },
        {
          headerName: this.$t('grid.column.nameGuest'),
          field: 'customer_full_name',
          width: 120,
          minWidth: 140,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.adult'),
          field: 'adult',
          width: 120,
          minWidth: 120,
          sortable: false,
          cellRenderer: 'CellRenderNumberInputBySum',
          cellRendererParams: params => {
            return {
              // allTranPageOptions
              disabled: params.node.lastChild,
              stringValue: params.data?.adult
            }
          },
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.child'),
          field: 'child',
          width: 120,
          minWidth: 120,
          sortable: false,
          cellRenderer: 'CellRenderNumberInputBySum',
          cellRendererParams: params => {
            return {
              // allTranPageOptions
              disabled: params.node.lastChild,

              stringValue: params.data?.child
            }
          },
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.infant'),
          field: 'infant',
          width: 120,
          minWidth: 120,
          sortable: false,
          cellRenderer: 'CellRenderNumberInputBySum',
          cellRendererParams: params => {
            return {
              // allTranPageOptions
              disabled: params.node.lastChild,
              stringValue: params.data?.infant
            }
          },
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.checkinDate'),
          field: 'arrive_date',
          sortable: false,
          minWidth: 130,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.checkoutDate'),
          field: 'depart_date',
          sortable: false,
          minWidth: 130,
          maxWidth: 160
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'desc',
          tooltipField: 'desc',
          sortable: false,
          cellRenderer: 'CellRenderNoteInput',
          minWidth: 200
        }
      ],
      rows: []
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onResetSearchParams() {
      this.searchParams.date = this.$moment(new Date()).format('YYYY-MM-DD')
      this.attachData()
    },
    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getHistoryBreakfast(this.searchParams)
      // bus.$emit("endLoader");
      this.loading = false
      this.rows = data.data
      this.listAssign = []
    },
    numberInputBySumChange(params, value, sum, colName, flagSave) {
      const idx = params.rowIndex
      const gridApi = this.$refs.agGrid.gridApi
      if (flagSave) {
        this.flagCanSave = true
      } else {
        this.flagCanSave = false
      }
      this.rows[idx][colName] = `${value}/${sum}`
    },
    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      if (colName === 'desc') {
        if (value?.length && value.length > 50) {
          value = value.slice(0, 50)
          this.$message({
            type: 'error',
            message: 'Số phòng vượt quá số phòng có sẵn'
          })
        }
        this.rows[idx][colName] = value
      }
    },
    async updateBreakfast() {
      if (this.flagCanSave) {
        await setHistoryBreakfast(this.rows)
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-containers {
  position: fixed;
  bottom: 30px;
  right: 20px;
}
</style>
